if (!customElements.get('salty-species-launch')) {
  class SaltySpeciesLaunch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.species = 'all';
      this.selectedStyle = 'all';
      this.products = Array.from(this.querySelectorAll('[data-species-product]'));
      this.count = this.querySelector('[data-species-count]');
      this.speciesButtons = Array.from(this.querySelectorAll('[data-species-filter]'));
      this.styleButtons = Array.from(this.querySelectorAll('[data-style]'));
      this.viewButtons = Array.from(this.querySelectorAll('[data-view]'));
      this.querySelector('[data-species-controls]').hidden = false;

      this.speciesButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.species = button.dataset.speciesFilter;
          this.speciesButtons.forEach((option) => {
            option.setAttribute('aria-pressed', String(option === button));
          });
          this.filterProducts();
        });
      });

      this.styleButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.selectedStyle = button.dataset.style;
          this.styleButtons.forEach((option) => {
            option.setAttribute('aria-pressed', String(option === button));
          });
          this.filterProducts();
        });
      });

      this.viewButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.dataset.imageView = button.dataset.view;
          this.viewButtons.forEach((option) => {
            option.setAttribute('aria-pressed', String(option === button));
          });
        });
      });

      this.querySelector('[data-species-reset]').addEventListener('click', () => {
        this.species = 'all';
        this.selectedStyle = 'all';
        this.speciesButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.speciesFilter === 'all'));
        });
        this.styleButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.style === 'all'));
        });
        this.filterProducts();
      });
    }

    filterProducts() {
      let count = 0;
      this.products.forEach((product) => {
        const speciesMatches = this.species === 'all' || product.dataset.species === this.species;
        const styleMatches = this.selectedStyle === 'all' || product.dataset.productStyle === this.selectedStyle;
        product.hidden = !speciesMatches || !styleMatches;
        if (!product.hidden) count += 1;
      });
      this.count.textContent = count === 1 ? this.count.dataset.one : this.count.dataset.other.replace('__count__', count);
      this.querySelector('[data-species-empty]').hidden = count !== 0;
    }
  }

  customElements.define('salty-species-launch', SaltySpeciesLaunch);
}

customElements.whenDefined('product-form').then(() => {
  if (customElements.get('species-product-form')) return;

  class SpeciesProductForm extends customElements.get('product-form') {
    constructor() {
      super();
      this.sizeSelect = this.querySelector('[data-size-select]');
      this.sizeSelect.addEventListener('change', () => this.updateSelection());
      this.updateSelection();
    }

    updateSelection() {
      const option = this.sizeSelect.selectedOptions[0];
      const available = Boolean(option?.value && option.dataset.available === 'true');
      const help = this.querySelector('[data-size-help]');
      help.hidden = option?.dataset.size !== '4XL';
      if (this.submitButton.classList.contains('loading')) return;

      this.error = false;
      this.handleErrorMessage();
      this.submitButton.removeAttribute('aria-disabled');
      this.toggleSubmitButton(!available, option?.value ? window.variantStrings.soldOut : this.dataset.chooseSize);
      this.form.querySelector('[name="quantity"]').value = option?.dataset.min || '1';

      if (available) {
        const price = this.closest('[data-species-product]').querySelector('.price');
        price.classList.toggle('price--on-sale', option.dataset.onSale === 'true');
        price.classList.remove('price--sold-out', 'price--no-compare');
        price.querySelector('.price__regular .price-item--regular').textContent = option.dataset.price;
        price.querySelector('.price__sale .price-item--sale').textContent = option.dataset.price;
        const compare = price.querySelector('.price__sale .price-item--regular');
        if (compare) compare.textContent = option.dataset.comparePrice;
      }
    }

    onSubmitHandler(event) {
      if (this.submitButton.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      const option = this.sizeSelect.selectedOptions[0];
      if (!option?.value || option.dataset.available !== 'true') {
        event.preventDefault();
        this.updateSelection();
        this.sizeSelect.focus();
        return;
      }
      super.onSubmitHandler(event);
      if (!this.submitButton.classList.contains('loading')) return;
      // Dawn has already captured FormData; keep the selected size stable until it finishes.
      this.sizeSelect.disabled = true;
      const completion = new MutationObserver(() => {
        if (this.submitButton.classList.contains('loading')) return;
        this.sizeSelect.disabled = false;
        completion.disconnect();
      });
      completion.observe(this.submitButton, { attributes: true, attributeFilter: ['class'] });
    }

    dispatchCartErrorEvent(message, code) {
      super.dispatchCartErrorEvent(message, code);
      if (code === 'SERVICE_UNAVAILABLE') this.handleErrorMessage(this.dataset.networkError);
    }
  }

  customElements.define('species-product-form', SpeciesProductForm);
});
